import React from 'react';
import { Link } from 'react-router-dom';
import '../../styles/service-style/Comprehensive-Therapetic-Services.css'; // Check spelling: should be "Therapeutic"
import Footer from '../../components/Footer';

import Physiotherapy from '../../assets/services logos/physiotherapy.jpg';
import occupational from '../../assets/services logos/occupational.jpg';
import speech from '../../assets/services logos/speech.jpg';
import psychology from '../../assets/services logos/psychology.jpg';

const servicesData = [
  { 
    id: 6, 
    title: "Physiotherapy Services", 
    description: "Relieve pain, restore movement, and speed recovery with personalized physiotherapy for orthopedic, neuro, and post-surgical care.", 
    image: Physiotherapy, 
    path: "/services/Physiotherapy-Services" 
  },
  { 
    id: 7, 
    title: "Occupational Therapy Services", 
    description: "Regain independence in daily life—ADL training, hand rehab, and assistive device solutions.", 
    image: occupational, 
    path: "/services/Occupational-Therapy" 
  },
  { 
    id: 8, 
    title: "Speech and Language Therapy Services", 
    description: "Personalized therapy for speech, language, fluency, voice, and swallowing—improving communication for all ages.", 
    image: speech, 
    path: "/services/Speech-Therpy" 
  },
  { 
    id: 9, 
    title: "Psychology Services", 
    description: "Confidential, evidence-based counseling and psychotherapy for anxiety, depression, trauma, and stress—supporting overall well-being.", 
    image: psychology,
    path: "/services/Psychology" 
  },
];

const ComprehensiveTherapeuticServices = () => {
  return (
    <div>
      <section className="home-services-section">
        <h1 className="home-services-heading">Comprehensive Services</h1>
        
        <p className="home-services-subtitle">
          Personalized therapies to restore movement, independence, communication, and mental well-being.
        </p>

        <div className="home-services-container">
          {servicesData.map((service) => (
            <div key={service.id} className="home-service-card">
              <img src={service.image} alt={service.title} className="home-service-image" />
              <div className="home-service-content">
                <h2 className="home-service-title">{service.title}</h2>
                <p className="home-service-description">{service.description}</p>
                <Link to={service.path} className="know-more-btn">Know More</Link>
              </div>
            </div>
          ))}
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ComprehensiveTherapeuticServices;
